import { Box, Typography } from '@mui/material';

export const EthicsPill = () => (
  <Box
    sx={{
      px: '6px',
      borderRadius: {
        xs: '8px',
        sm: '3px',
      },
      bgcolor: 'secondary.light',
      border: theme => `1px solid ${theme.palette.secondary.main}80`,
      height: 23,
      display: 'flex',
      alignItems: 'center',
    }}>
    <Typography
      variant="caption1Bold"
      sx={{
        color: 'secondary.main',
      }}>
      Ethics
    </Typography>
  </Box>
);
